// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","366":"f85a49c96e183f4c3688717319e60b9d357b530e","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"0244fe4c93af3645bf67","366":"619782888f1efe891380","691":"911cf24e4cf73acf46ab"}[chunkId] + ".js";
};